import _ from 'lodash'

/**
 * @typedef DatasetRecord
 * @property {string[]|number[]} record
 * @property {boolean[]} edited
 * @property {string[]|number[]} originalRecord
 * @property {number} generatedKey
 * @property {boolean} new
 * @property {boolean} insert
 * @property {boolean} autogeneratedId
 * Contains various information about the record and follows
 * the schema of DatasetRecord.java.
 */
const DEFAULT_DATASET_RECORD = {
	record: [],
	edited: [],
	originalRecord: [],
	generatedKey: null,
	new: null,
	insert: null,
	autogeneratedId: null
}

/**
 * @param {DatasetRecord} datasetRecord
 * @return {DatasetRecord}
 */
function createDatasetRecord(datasetRecord) {
	_.forEach(_.keys(DEFAULT_DATASET_RECORD), key => {
		if (key === 'autogeneratedId') return
		// don't need these properties if this is the first time saving a manually added record
		const firstTimeSavingManualRecord = !!datasetRecord.new && !!datasetRecord.insert
		if (firstTimeSavingManualRecord &&
			(key === 'originalRecord' || key === 'generatedKey')) return

		if (_.isNil(datasetRecord[key])) {
			throw new Error(`DatasetRecord is missing the property: ${key}`)
		}
	})

	return datasetRecord
}

export default createDatasetRecord
createDatasetRecord.__filename__ = 'datasets/model/dataset-record.js'
